module.exports = __webpack_public_path__ + "img/sand-rock-medium-16.ddb67732.png";